import React from 'react';
import styled, { css } from 'styled-components';
import { flexCenterAll, showInPrintOnly } from '../../styles/mixins';
import type { CSSDimensionValue, TControlSize } from '../../tokens/types';
import { vars } from '../../theme';
import { SIZES } from './HBCheckbox';

// Due to a problem with Checkbox visibility, this is a solution for pdf printing.

export interface Props {
    size: TControlSize;
    color: string;
    isActive: boolean;
    children: React.ReactNode;
    margin: CSSDimensionValue;
}

const MockPrintCheckboxButton = ({
    size,
    color,
    isActive,
    children,
    margin
}: Props) => {
    return (
        <Box size={size} color={color} $isActive={isActive} $margin={margin}>
            <Check size={size} $isActive={isActive}>
                {children}
            </Check>
        </Box>
    );
};

export default MockPrintCheckboxButton;
// -------------------------------- Styles -------------------------------- //
const Box = styled.div<{
    size: TControlSize;
    color: string;
    $isActive: boolean;
    $margin: CSSDimensionValue;
}>`
    ${flexCenterAll}
    ${showInPrintOnly('flex')}
    ${props => SIZES[props.size]};
    border-radius: ${vars.radius.xs};
    border: 1px solid;
    border-color: ${vars.colors.text.tertiary};

    ${({ $isActive, color }) =>
        $isActive &&
        css`
            background: ${color || vars.colors.text.primary};
            border-color: ${color || vars.colors.text.primary};
        `};

    * {
        width: 100%;
        height: 100%;
    }
    ${props =>
        props.$margin &&
        css`
            margin: ${props.$margin};
        `}
`;

const Check = styled.div<{ size: TControlSize; $isActive: boolean }>`
    opacity: ${props => (props.$isActive ? 1 : 0)};
`;
